define("settings/routes/groups/index", ["exports", "@ember/routing/route", "@ember/service", "@ember/template", "@glimmer/tracking"], function (_exports, _route, _service, _template, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _checkOverages;
  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route",0,"@ember/service",0,"@ember/template",0,"@glimmer/tracking"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let IndexRoute = _exports.default = (_class = (_checkOverages = /*#__PURE__*/new WeakSet(), class IndexRoute extends _route.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _checkOverages);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "settings", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      _defineProperty(this, "groupSorting", ['name']);
      _initializerDefineProperty(this, "groups", _descriptor6, this);
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get isGracePeriod() {
      return Boolean(this.subscriptions.subscription?.isGracePeriod);
    }
    async model() {
      await this.subscriptions.getAllSubscriptionPlans();
      const {
        groups
      } = this.auth;
      if (this.settings.isAccountOwner) {
        return groups;
      }
      return groups.filter(group => {
        const membershipIds = group.memberships.filterBy('isContributor', false).mapBy('user.id');
        return membershipIds.includes(this.auth.currentUserModel.id);
      });
    }
    afterModel(groups) {
      this.groups = groups;
      _classPrivateMethodGet(this, _checkOverages, _checkOverages2).call(this);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "groups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  })), _class);
  function _checkOverages2() {
    const account = this.currentAccount;
    if (account?.shouldWarnOfPlanOverages && !this.isGracePeriod) {
      if (account.hasGroupsOverage) {
        this.alerts.warning(this.intl.t('alerts.account.groups.overages', {
          count: account.groupsOverage
        }), {
          title: this.intl.t('alerts.account.overage')
        });
      }
      if (account.hasSocialProfileOverage) {
        const profileOverages = [account.hasInstagramOverage ? {
          type: 'Instagram',
          count: account.instagramOverage
        } : undefined, account.hasFacebookOverage ? {
          type: 'Facebook',
          count: account.facebookOverage
        } : undefined, account.hasPinterestOverage ? {
          type: 'Pinterest',
          count: account.pinterestOverage
        } : undefined, account.hasTwitterOverage ? {
          type: 'Twitter',
          count: account.twitterOverage
        } : undefined].filter(item => item).map(profile => `<li>${this.intl.t('alerts.account.groups.group.social_profiles.overages.profiles', profile)}</li>`);
        const overageList = `<ul>${profileOverages}</ul>`;
        this.alerts.warning(this.intl.t('alerts.account.groups.group.social_profiles.overages.title', {
          count: account.groupsOverage,
          list: (0, _template.htmlSafe)(overageList)
        }), {
          title: this.intl.t('alerts.account.overage')
        });
      }
    }
  }
});